<template>
  <el-dialog title="选择仓库" :visible.sync="dialogVisible" @close="cancelFunc" :append-to-body="true" 
  :close-on-click-modal="false" :close-on-press-escape="false" width="880px">
    
  <div class="common-seach-wrap">
    
  
    <el-form :inline="true" size="small"  class="demo-form-inline">
         
         <el-form-item >
           <el-input style="width: 45%;float: left;" placeholder="请输入仓库名称" v-model="search">
         
          </el-input>
           <el-button  style="width: 25%;float: left;margin-left: 2%;" type="primary" icon="el-icon" @click="getWarehouse">查询</el-button>
           <el-button  style="width: 25%;float: left;margin-left: 2%;background: #999;border: 1px solid #999;" type="primary" icon="el-icon" @click="reast">重置</el-button>
           <div style="clear: both;"></div>
         </el-form-item>

     </el-form>  
       
       
     <el-table
     
           :data="WarehouseList"
           highlight-current-row
           border
           style="width: 100%"
           @selection-change="handleSelectionChange"
           >

           <el-table-column prop="name" label="仓库名称" > </el-table-column>
           <el-table-column prop="warehouse_kw_id" label="ID" > </el-table-column>
           <el-table-column prop="numb" label="编号" > </el-table-column>
         
           <el-table-column label="操作" width="80" >
           <template slot-scope="scope">
             <el-button type="primary" size="mini" @click="selectw(scope.row)">选择</el-button>
           </template>
         </el-table-column>
         </el-table>
    

    
    </div>
  </el-dialog>
  </template>
  
  <script>

    import WarehouseApi from '@/api/warehouse.js';
 
    export default {

      inject: ['reload'],
      data() {
        return {
        
             /*选中的*/
        multipleSelection: [],
        /*是否显示*/
        dialogVisible: false,
  
          search:"",
          WarehouseList:[],
          currentRow :null
        };
      },
      created() {
        this.dialogVisible = this.is_open;
        this.getWarehouse();
 
      },
      props: {
        // 开启弹窗
        is_open: Boolean,
        // 是否多选
        multi: {
          type: Boolean,
          default: () => {
            return true
          }
        },
        selectlist: {
          type: Array,
          default: () => {
            return []
          }
        },
    },
      methods: {

      //   handleCurrentChange(val) {
    
      //       this.currentRow = val;
 
      //      let self = this;
   
      //      this.$emit("handleCurrentChange", { openDialog: false,
      //       "warehouse_id":val.warehouse_id,
      //       "warehouse_kw_id":val.warehouse_kw_id
      //       });
      // },
            /*选择门店*/
            handleSelectionChange(e) {
        this.multipleSelection = e;
      },
      /*监听单选按钮选中事件*/
      selectw(val) {
        this.multipleSelection = val;
        this.confirmFunc();
      },
      reast() {
    
                this.currentRow = null;
                this.$emit("reast", { openDialog: false,"id":0 });
            },
        getWarehouse() {
            let self = this;
            self.loading = true
            let Params = {}
            Params.page = 1
            Params.list_rows = 9000
            Params.search = self.search
            WarehouseApi.list(Params, true)
              .then(data => {
                self.loading = false
                self.WarehouseList = data.data.list.data
   
              })
              .catch(error => {
                self.loading = false
              });
      },
          /*点击确定*/
          confirmFunc() {
        let params = this.multipleSelection;
        this.sure_close = true;
        this.emitFunc( params);
      },
  
      /*关闭弹窗*/
      cancelFunc(e) {

        if(!this.sure_close){
          this.emitFunc();
        }
       
      },
          /*发送事件*/
          emitFunc(e) {
        this.dialogVisible = false;
        if (e && typeof e != 'undefined') {
          this.$emit('closex', {
            type: 'success',
            params: e
          });
        } else {
          this.$emit('closex', {
            type: 'error'
          });
        }
      },
      }
    };
  </script>
  
  <style></style>
  


// WEBPACK FOOTER //
// src/components/select/warehouses.vue